import { useRoute } from 'vue-router'
import type { FeedbackTopic } from '../../../core/models/feedback-topic'
import type { Scale } from '../../../core/models/scale'
import useGet from '../../../core/composables/api/useGet'
import { computed, watch, toValue, type MaybeRef } from 'vue'

export const usePrepareJournalSlide = (feedbackTopicId: MaybeRef<string>) => {
  const route = useRoute()

  const url = computed(() => {
    return `dialog/prepare/${route.params.id}/journal-slide/${toValue(feedbackTopicId)}`
  })

  const { data, load, status } = useGet<DialogJournalSlide>(url)

  watch(url, () => {
    load()
  }, { immediate: true })

  return { data, status }
}

export interface DialogJournalSlide {
  readonly analysis: JournalAnalysis
  readonly feedbackTopic: FeedbackTopic
}

export interface JournalAnalysis {
  scale: Scale
  progress: ReadonlyArray<{
    date: string
    average: number
  }>
  latestValue?: {
    date: string
    average: number | null
    feedbacks: ReadonlyArray<{
      questionId: string
      value: number | null
      text: JSON | null
    }>
  }
  questions: ReadonlyArray<{
    id: string
    text: string
  }>
}
